export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: name, ...params })
}

export function trackPageView(path, title) {
  if (typeof window === 'undefined') return
  trackEvent('page_view', {
    page_location: window.location.href,
    page_path: path,
    page_title: title,
  })
}
